import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ApiMananger } from 'actions/rtkquery';
import HeaderFirst from 'utils/HeaderFirst';
import CustomBootstrapTable from 'utils/reactTable';
import { useNavigate, useParams } from 'react-router-dom';
import './client.css';
import TablePaginators from './TablePaginator';
import { FiPaperclip } from 'react-icons/fi';
import { FaFileImport } from 'react-icons/fa';
import { ADD_VENTE } from 'routes/navigation/navigationPaths';
import HeaderButton from 'utils/headerButton';
import useVentesData from './useVentesData';
import { toast } from 'react-toastify';
import ModalImportEntrees from 'pagesDossierClientCabinet/SaisieManuelle/ModalImportEntrees';
import { useDeleteVenteMutation } from 'actions/ventes/mutations';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal';
import TableLoader from 'components/Loader/TableLoader';

const VentePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientID: dossier_id } = useParams();
  console.log(dossier_id);
  const { updatedVentes, handleUpdateVente, refetch, isLoading } = useVentesData(dossier_id);
  const [deleteVente, { isLoading: isDeleting }] = useDeleteVenteMutation();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const donnees = updatedVentes;
  console.log({ donnees });
  const [selectedRows, setSelectedRows] = useState([]);
  const [serachTerm, setSearchedTerm] = useState('');

  const handleRowSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows((prev) => [...prev, row.id]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== row.id));
    }
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchedTerm(newSearchTerm);
  };

  

  const columns = [
    {
      dataField: 'id',
      text: 'N°',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell}
        </div>
      ),
    },
    {
      dataField: 'client_details',
      text: 'Nom du client',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell.nom}
        </div>
      ),
    },
    {
      // dataField: 'username',
      text: 'Fait par',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {row.created_by_details?.first_name || 'N/A'}
        </div>
      ),
    },
    {
      dataField: 'updated_at',
      text: 'Date',
      formatter: (cell, row) => {
        // Priorite a la date de transaction (date Odoo), fallback updated_at
        const rawDate = row.date_transaction || cell;
        const date = new Date(rawDate);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        if (row.date_transaction) {
          return <div onClick={() => handleRowSelect(row)}>{`${day}/${month}/${year}`}</div>;
        }

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return <div onClick={() => handleRowSelect(row)}>{`${day}/${month}/${year} à ${hours}:${minutes}`}</div>;
      },
    },
    {
      dataField: 'statut_paiement',
      text: 'Statut',
      formatter: (cell, row) => {
        const statusMap = {
          PAYE: { label: 'Payé', color: '#065f46', bg: '#d1fae5' },
          PARTIEL: { label: 'Partiel', color: '#92400e', bg: '#fef3c7' },
          NON_PAYE: { label: 'Non payé', color: '#991b1b', bg: '#fee2e2' },
          RETARD: { label: 'En retard', color: '#7f1d1d', bg: '#fecaca' },
        };
        const status = statusMap[cell] || { label: cell || 'Active', color: '#374151', bg: '#f3f4f6' };
        return (
          <div
            onClick={() => handleRowSelect(row)}
            style={{
              color: status.color,
              backgroundColor: status.bg,
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: 600,
              display: 'inline-block',
            }}
          >
            {status.label}
          </div>
        );
      },
    },
    {
      dataField: 'source_paiement',
      text: 'Paiements',
      formatter: (cell, row) => {
        const labels = {
          caisse: 'Caisse',
          banque: 'Banque',
          wave: 'Wave',
          orange_money: 'Orange Money',
          monnaie_electronique: 'Monnaie électronique',
        };
        const label = labels[cell] || (cell ? String(cell) : '-');
        return (
          <div className="styleColonne" onClick={() => handleRowSelect(row)}>
            {label}
          </div>
        );
      },
    },
    {
      dataField: 'prix',
      text: 'Prix',
      formatter: (cell, row) => {
        // Somme des lignes produit si presentes, sinon le prix de l'entree
        // (mode migration Odoo : pas de lignes produit, prix direct)
        const Price = row?.produits_associes?.length
          ? row.produits_associes.reduce(
              (sum, prod) => sum + parseFloat(prod.prix || 0),
              0
            )
          : (row?.prix ?? row?.montant_total ?? 0);
        return (
          <div onClick={() => handleRowSelect(row)}>{Number(Price).toFixed(2)}</div>
        );
      },
    },
    {
      dataField: 'piece_joint',
      text: <FiPaperclip />,
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell ? (
            <a href={cell} target="_blank" rel="noopener noreferrer">
              Pièce jointe
            </a>
          ) : (
            <span>pas pièce jointe</span>
          )}
        </div>
      ),
    },
    {
      dataField: 'montant_total',
      text: 'Total',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowSelect(row)}>
          {cell}
        </div>
      ),
    },
  ];

  const [pageSize, setPageSize] = useState(10);
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [viewArchived, setViewArchived] = useState(false);

  const handlePageChange = (newIndex) => {
    setPaginationIndex(newIndex);
  };

  const currentPageData = donnees
    .filter((vente) => (viewArchived ? vente.archived : !vente.archived))
    // Show all if viewArchived is false, else filter by archived status
    .filter((vente) =>
      vente.client_details?.nom
        ?.toLowerCase()
        .includes(serachTerm.toLowerCase())
    )
    .slice(paginationIndex * pageSize, (paginationIndex + 1) * pageSize);

  // Define the action handler for TablePaginator
  const handleActionSelected = (action) => {
    if (action === 'archive') {
      setViewArchived(!viewArchived); // Toggle between viewing archived and active depenses
    } else {
      console.log(`Action selected: ${action}`);
      // Handle other actions as necessary
    }
  };

  const onClickArchive = async () => {
    if (selectedRows.length === 0) {
      toast.warning('Veuillez sélectionner au moins une entrée à archiver.');
      return;
    }

    try {
      // Déterminer le statut basé sur la première entrée sélectionnée
      const firstVente = currentPageData.find((d) => d.id === selectedRows[0]);
      if (!firstVente) {
        toast.error('Entrée non trouvée.');
        return;
      }

      const newArchivedStatus = !firstVente.archived;
      
      // Archiver/Désarchiver toutes les entrées sélectionnées
      const updatePromises = selectedRows.map((id) => {
        const vente = currentPageData.find((d) => d.id === id);
        if (vente) {
          return handleUpdateVente(id, { archived: newArchivedStatus })
            .catch(error => {
              console.error(`Erreur mise à jour entrée ${id}:`, error);
              return { error, id };
            });
        }
        return Promise.resolve();
      });

      const results = await Promise.all(updatePromises);
      
      // Vérifier s'il y a eu des erreurs
      const errors = results.filter(r => r && r.error);
      const successes = selectedRows.length - errors.length;
      
      if (successes > 0) {
        toast.success(
          `${successes} entrée(s) ${newArchivedStatus ? 'archivée(s)' : 'désarchivée(s)'} avec succès.`
        );
      }
      
      if (errors.length > 0) {
        toast.error(`${errors.length} entrée(s) n'ont pas pu être mise(s) à jour.`);
      }
      
      setSelectedRows([]); // Réinitialiser la sélection
    } catch (error) {
      toast.error(
        'Une erreur est survenue lors de la mise à jour des entrées.'
      );
      console.error('Erreur lors de la mise à jour des entrées :', error);
    }
  };

  const onClickDelete = () => {
    if (selectedRows.length === 0) {
      toast.warning('Veuillez sélectionner au moins une entrée à supprimer.');
      return;
    }
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // Supprimer toutes les ventes sélectionnées
      const deletePromises = selectedRows.map((id) => 
        deleteVente(id).unwrap().catch(error => {
          console.error(`Erreur suppression entrée ${id}:`, error);
          return { error, id };
        })
      );
      
      const results = await Promise.all(deletePromises);
      
      // Vérifier s'il y a eu des erreurs
      const errors = results.filter(r => r && r.error);
      const successes = selectedRows.length - errors.length;
      
      if (successes > 0) {
        toast.success(
          `${successes} entrée(s) supprimée(s) avec succès. ` +
          `Les calculs comptables ont été mis à jour.`
        );
      }
      
      if (errors.length > 0) {
        errors.forEach(({ error, id }) => {
          const errorMessage = error?.data?.detail || error?.data?.error || error?.data?.message || `Erreur lors de la suppression de l'entrée ${id}`;
          toast.error(errorMessage);
        });
      }
      
      setSelectedRows([]); // Réinitialiser la sélection
      setShowDeleteModal(false);
      refetch(); // Recharger les données
      
      // Invalider MANUELLEMENT les caches des créances/dettes
      dispatch(ApiMananger.util.invalidateTags(['INVALIDATE_CREANCES', 'INVALIDATE_DETTES', 'INVALIDATE_DOSSIER']));
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      const errorMessage = error?.data?.error || error?.data?.message || 'Erreur lors de la suppression des entrées';
      toast.error(errorMessage);
      setShowDeleteModal(false);
    }
  };

  const DepensebuttonActions = {
    addExpense: () => {
      alert('Ajouter une action de dépense');
    },
  };

  const nom = (
    <div style={{ display: 'flex' }}>
      <h4 className="titre-dossier">Entrées</h4>
      <span className="nbrDossier">{currentPageData?.length}</span>
    </div>
  );
  const description = (
    <div>Voici toutes vos entrées {viewArchived && 'archivées'}</div>
  );

  const handleEyesClick = () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const detailVenteURL = `${selectedRowId}/`;
      navigate(detailVenteURL);
    }
  };

  const handleFormVente = () => {
    navigate(ADD_VENTE);
  };

  const openImportModal = () => setIsImportModalOpen(true);
  const closeImportModal = () => setIsImportModalOpen(false);
  const handleImportSuccess = () => {
    closeImportModal();
    refetch();
  };

  return (
    <div
      className="global"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <div
        className="header pb-3"
        style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          flexWrap: 'wrap',
          // padding: "13px",
        }}
      >
        <HeaderFirst nom={nom} description={description} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="btn btn-outline-primary"
            style={{
              borderRadius: '31px',
              border: '1px solid #009688',
              padding: '8px 16px',
              backgroundColor: '#009688',
              color: 'white',
              fontSize: '14px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
            onClick={openImportModal}
          >
            <FaFileImport />
            <span>Importer des entrées</span>
          </button>
          <button
            type="button"
            className="btn btn-outline-dark"
            style={{
              borderRadius: '31px',
              border: '1px solid #AEAEAE',
              padding: '8px',
            }}
            onClick={handleFormVente}
          >
            <span style={ajoutFou}>+ Ajouter une entrée</span>
          </button>
        </div>
      </div>
      <HeaderButton
        isButtonsEnabled={selectedRows.length > 0}
        placeholder={'Rechercher une vente'}
        onSearchChange={handleSearchChange}
        onEyesClick={handleEyesClick}
        buttonActions={DepensebuttonActions}
        onClickArchive={onClickArchive}
        onClickDelete={onClickDelete}
        // onEditClick={onEditClick}
      />

      <div>
        {isLoading && (!donnees || donnees.length === 0) ? (
          <div style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', border: '1px solid #e2eced' }}>
            <TableLoader
              message="Chargement des ventes (entrées)..."
              subMessage="Récupération des opérations et des détails clients"
              minHeight="280px"
            />
          </div>
        ) : donnees ? (
          <CustomBootstrapTable
            keyField="id"
            data={currentPageData.filter((vente) =>
              vente.client_details?.nom
                ?.toLowerCase()
                ?.includes(serachTerm.toLowerCase())
            )}
            columns={columns}
            selectedRows={selectedRows}
            onSelectRow={handleRowSelect}
          />
        ) : null}
      </div>
      {!isLoading && (!currentPageData || currentPageData.length === 0) && (
        <div className="d-flex justify-content-center fs-5 mt-4 text-muted">
          <p>Aucune vente à afficher.</p>
        </div>
      )}
      {/* pagination */}
      {currentPageData && (
        <TablePaginators
          paginationIndex={paginationIndex}
          setPaginationIndex={handlePageChange}
          dataLength={currentPageData?.length}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onActionSelected={handleActionSelected}
          isViewingArchived={viewArchived}
        />
      )}
      <ModalImportEntrees
        isOpen={isImportModalOpen}
        onClose={closeImportModal}
        dossierId={dossier_id}
        onSuccess={handleImportSuccess}
      />
      
      <ConfirmDeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        itemCount={selectedRows.length}
        itemType="entrée"
        isLoading={isDeleting}
      />
    </div>
  );
};

const ajoutFou = {
  fontFamily: 'Montserrat',
  fontWeight: '600',
  fontSize: '13px',
};
export default VentePage;
